import { getErrorMetaData } from '@jucy-nakuru/common/lib/errorHandler';
import getLogger from '@jucy-nakuru/common/services/loggerFactory';
import { ChildLoggerOptions } from 'pino';
import VError from 'verror';
import ErrorReporter from '../lib/ErrorReporter';

type CaptureExceptionLogger = ReturnType<typeof getLogger> & {
    captureException(error: Error | VError, meta?: unknown): void;
};

const extractTags = (meta: unknown): Record<string, string> | undefined => {
    if (!meta) {
        return undefined;
    }
    const tags: Record<string, string> = {};
    Object.entries(meta).forEach(([key, value]) => {
        if (typeof value === 'string') {
            tags[key] = value;
        }
    });
    return tags;
};

const createLogger = <ChildOptions extends ChildLoggerOptions>(module: NodeJS.Module | ImportMeta | string, options?: ChildOptions) => {
    let moduleName = module;
    if (typeof moduleName === 'string' && moduleName.startsWith('file:')) {
        moduleName = moduleName.split('/').pop() || module;
    }

    const logger = getLogger(moduleName, options) as CaptureExceptionLogger;
    logger.captureException = (error: Error | VError, meta?: unknown) => {
        const extendedMeta = {
            ...getErrorMetaData(error as Error),
            ...(typeof meta === 'object' ? meta : undefined),
        };
        logger.error(error.message, extendedMeta);
        ErrorReporter.reportError({
            error,
            level: 'error',
            tags: extractTags(meta),
            extraInfo: extendedMeta,
        });
    };
    return logger;
};

export default createLogger;
